const queueFilesForUpload = async ({files, upload, uploadsDispatch, assetGroupDispatch, apiClient}) => {
    let activeUpload = upload

    if(upload.upload_state === 'cancelled') {
        const response = await apiClient.post(`/api/uploads/${upload.id}/reactivate`)
        activeUpload = {...upload, ...response.data}

        assetGroupDispatch({type: 'updateCurrentUpload', upload: activeUpload})
        uploadsDispatch({type: 'setUploadState', uploadState: activeUpload.upload_state})
    }

    uploadsDispatch({type: 'addFiles', files, upload: activeUpload})
    assetGroupDispatch({type: 'reloadContributionId', id: activeUpload.contribution.id})

    return activeUpload
}

export {queueFilesForUpload}
